import React, { forwardRef, useState } from "react";
import { FaStar } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import popup from "../img/popup.png";
import axios from "axios";
import { FaSpinner } from "react-icons/fa6";

const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

const Review = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    email: "",
    message: ""
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessages, setErrorMessages] = useState({
    email: "",
    message: ""
  });
  const [isLoading, setIsLoading] = useState(false);

  const isValid = () => {
    let errorMessages_ = {
      email: "",
      message: ""
    }
    if (!formData.email.trim()) {
      errorMessages_.email = "Enter your email address.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errorMessages_.email = "Enter a valid email address."
    }
    if (!formData.message.trim()) {
      errorMessages_.message = "Enter your message.";
    }

    if (errorMessages_.email || errorMessages_.message) {
      setErrorMessages(errorMessages_);
      return false;
    } else {
      return true;
    }
  };

  const handleSendEmail = async () => {
    if (isLoading) return;

    if (!isValid()) return;

    setIsLoading(true);

    try {
      console.log("Sending email from Review component via backend API");
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/send-email`, {
        sender: 'edu@angelwatch.org',
        to: ['edu@angelwatch.org'],
        subject: `New Message From ${formData.email}`,
        html_body: `<p>You got a new customer. Email address is <strong>${formData.email}</strong>.</p><p>${formData.message}</p>`
      });

      console.log("Email sent successfully from Review component:", response.data);
      setSuccessMessage("Thank you! We will get back to you asap!");
      setIsLoading(false);
      setFormData({
        email: "",
        message: ""
      });
      setErrorMessages({
        email: "",
        message: ""
      });
    } catch (err) {
      console.error("Email sending failed from Review component:", err);
      setErrorMessage(err.response?.data || err.message);
      setIsLoading(false);
    }
  }

  const handleChangeForm = (type, value) => {
    setFormData({
      ...formData,
      [type]: value
    });
    setErrorMessage("");
    setSuccessMessage("");
  }

  return (
    <div ref={ref} id="review-contact" className="bg-[#FCF7EE] py-8 sm:py-10 lg:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24">
        {/* Left Side: Review Section */}
        <div>
          <h4 className="text-red-500 font-bold mb-2 text-sm sm:text-base">
            Reviews
          </h4>
          <h3 className="text-xl sm:text-2xl md:text-3xl text-black font-semibold mb-6 leading-snug">
            Proven Results From Across The Country
          </h3>

          <Slider {...settings}>
            {props.reviews.map((review, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center lg:items-start lg:text-left px-2 sm:px-4"
              >
                <p className="text-gray-700 mb-4 text-base sm:text-lg md:text-xl max-w-2xl">
                  “{review.text}”
                </p>
                <div className="flex justify-center lg:justify-start space-x-1 text-yellow-400 mb-2">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <FaStar key={i} />
                    ))}
                </div>
                <span className="text-base sm:text-lg font-semibold text-black">
                  {review.name}
                </span>
                <div className="text-sm sm:text-base text-black font-medium">
                  {review.work}
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Right Side: Contact Form */}
        <div className="relative bg-white shadow-md rounded-lg p-5 sm:p-6 lg:p-8 h-fit ">
          {/* Popup Image */}
          <a href="/contactUs">
            <img
              src={popup}
              alt="popup"
              className="absolute top-[-40px] right-[-10px] lg:right-[-50px] w-35 sm:w-40  lg:w-56 z-0"
            />
          </a>
          <div className="relative z-10">
            <div className="text-[#FF386A] font-semibold text-lg mb-2 sm:mb-3">
              Have a question? Contact Us
            </div>

            <div className="flex flex-col mt-14 gap-3 mt-8">
              <input
                value={formData.email}
                onChange={(e) => handleChangeForm("email", e.target.value)}
                placeholder="Enter your email address"
                className="px-4 h-[40px] sm:h-[45px] text-black py-2 border border-black rounded-md text-sm sm:text-base"
              />
              {errorMessages.email ? (<p className="text-lg text-red-600 mt-1">{errorMessages.email}</p>) : <></>}
              <textarea
                value={formData.message}
                onChange={(e) => handleChangeForm("message", e.target.value)}
                placeholder="Enter your question."
                className="px-4 h-[80px] text-black py-2 border border-black rounded-md text-sm sm:text-base"
                row="5"
              >
              </textarea>
              {successMessage ? (<p className="text-lg text-green-600 mt-1">{successMessage}</p>) : <></>}
              {errorMessages.message ? (<p className="text-lg text-red-600 mt-1">{errorMessages.message}</p>) : <></>}
              {errorMessage ? (<p className="text-lg text-red-600 mt-1">{errorMessage}</p>) : <></>}
              <button
                onClick={handleSendEmail}
                className="bg-[#F0AA00] h-[50px] sm:h-[55px] text-white text-base sm:text-lg font-semibold px-5 py-2 rounded-md hover:bg-yellow-500 transition flex justify-center items-center"
                disabled={isLoading ? true : false}
              >
                {isLoading ? <FaSpinner className="animate-spin" /> : "Contact Us"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Review;
